/* eslint-disable no-unused-vars */
import { type AccountTypeEnum } from '../constants/api/account-type-enum'

export type AccountType = AccountTypeEnum.BROKERAGE | AccountTypeEnum.TRADITIONAL

export enum LinkingType {
  PLAID_INSTANT = 'INSTANT',
  MANUAL = 'MANUAL',
  NOT_SET = 'NOT_SET',
}
